const defaultFontStack = [
  "Ubuntu",
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "Helvetica",
  "Arial",
  "sans-serif",
  "Apple Color Emoji",
  "Segoe UI Emoji",
  "Segoe UI Symbol",
];

const monoFontStack = [
  "SFMono-Regular",
  "Consolas",
  "Liberation Mono",
  "Menlo",
  "Courier",
  "monospace"
];

export default {
  sizeSm: "16px",
  sizeMd: "18px",
  default: defaultFontStack.join(", "),
  heading: ["Ubuntu", ...defaultFontStack].join(", "),
  mono: monoFontStack.join(", ")
};
